export default __webpack_public_path__ + "static/new-york-1cc69ca3f1665fbfe6a51fabb1ba84ba.png";